import { IWorkoutStatisticsSummary } from "../models/workoutStatisticsViewModel";
import { formatVolume } from "../utils/statisticsFormat";
import styles from "../WorkoutStatistics.module.scss";

interface ISummaryCardsProps {
  summary: IWorkoutStatisticsSummary;
}

/** Hevy-style headline cards for the whole period. */
export const SummaryCards = ({ summary }: ISummaryCardsProps) => {
  const cards: { label: string; value: string }[] = [
    { label: "Тренировки", value: summary.workoutCount.toLocaleString("bg-BG") },
    { label: "Обем", value: formatVolume(summary.totalVolumeKg) },
    { label: "Серии", value: summary.totalSets.toLocaleString("bg-BG") },
    { label: "Повторения", value: summary.totalReps.toLocaleString("bg-BG") },
  ];

  return (
    <div className={styles.cards}>
      {cards.map((card) => (
        <div className={styles.card} key={card.label}>
          <span className={styles.card_value}>{card.value}</span>
          <span className={styles.card_label}>{card.label}</span>
        </div>
      ))}
    </div>
  );
};
